import {useEffect, useState} from 'react'
import {useShopperBasketsMutation} from '@salesforce/commerce-sdk-react'
import {buildPriceTestParam} from '@/helpers/sfccHelpers'
import {useCurrentBasket} from './useCurrentBasket'

export const useCreateBasket = ({
    customer,
    enabled
}: {
    customer: {
        customerId?: string
        email?: string
    }
    enabled: boolean
}) => {
    const {customerId, email} = customer || {}
    const [createdBasketId, setCreatedBasketId] = useState<string | null>(null)

    const createBasketMutation = useShopperBasketsMutation('createBasket')

    // Handles basket creation
    const createBasket = async () => {
        const result = await createBasketMutation.mutateAsync({
            parameters: {...buildPriceTestParam()},
            body: {
                customerInfo: {
                    customerId: customerId ?? undefined,
                    email: email ?? 'guest'
                }
            }
        })

        setCreatedBasketId(result?.basketId)
        return result
    }

    useEffect(() => {
        if (!enabled || !customerId) return
        if (
            !createdBasketId &&
            !createBasketMutation.isLoading &&
            !createBasketMutation.isSuccess
        ) {
            void createBasket().catch(() => {})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, customerId])

    // Only enable useCurrentBasket after basket is created
    const currentBasket = useCurrentBasket({
        enabled: !!createdBasketId,
        id: createdBasketId ?? ''
    })

    return {
        isLoading: createBasketMutation.isLoading || currentBasket.isLoading,
        data: createdBasketId ? currentBasket.data : createBasketMutation.data,
        error: createBasketMutation.error || currentBasket.error
    }
}
